
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { CashPaymentAdd, CashPaymentLocation } from '@app/views/pages/deposit/cash/models';
import { CashPaymentList } from '../models/cash-payment-list';

@Injectable({
	providedIn: 'root'
})
export class CashPaymentService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private httpClient: HttpClient,
		private utilsService: UtilsService
	) { }


	addCashPayment(cashPayment: CashPaymentAdd): Observable<any> {
		const formData: FormData = new FormData();

		for (const key in cashPayment) {
			if (cashPayment.hasOwnProperty(key)) {

				if (cashPayment[key] instanceof File) {
					formData.append(this.utilsService.upperCaseFirstLetter(key), cashPayment[key], cashPayment[key].name);
				} else {
					formData.append(this.utilsService.upperCaseFirstLetter(key), cashPayment[key]);
				}
			}
		}

		return this.httpClient
			.post<CashPaymentAdd>(`${this.appConfig.apiEndpoint}/new-core/payments/cash`, formData, {
				reportProgress: true,
				observe: 'events'
			})
			.pipe(map(response => response || {} as HttpEvent<any>));
	}

	getLocations(): Observable<CashPaymentLocation[]> {
		return this.httpClient
			.get<CashPaymentLocation[]>(`${this.appConfig.apiEndpoint}/new-core/payments/cash/locations`)
			.pipe(
				map(response => response['data'] || {})
			);
	}

	downloadDocument(paymentId: string, fileDownloadName: string): Observable<any> {
		const url = `${this.appConfig.apiEndpoint}/new-core/payments/cash/${paymentId}/attachments/${fileDownloadName}/download`;

		return this.httpClient.get(url, { observe: 'response', responseType: 'blob' });
	}

	deletePayment(requestId: string, paymentId: string): Observable<any> {
		const url = `${this.appConfig.apiEndpoint}/new-core/payments/cash/${paymentId}`;
		return this.httpClient
			.delete(url)
			.pipe(
				map(response => response['data'] || {}),
			);
	}
}